import FormField from "../form-field";
import Api from "../../../../lib/api";
import EnvHelper from "../../../../lib/env-helper";
import Select from "../components/select";

export default class CourseField extends FormField {
    constructor(props = {}) {
        super(props);

        this.GET_ENTRYID_ON_VALUE_CHANGE_EVENT = 'getEntryIdOnValueChange';
    }

    _beforeInit() {
        this.loading = true;

        this._checkProps();
        this._initElements();

        this.select = new Select({
            $root: this.$input,
            subscriptions: [{
                event: 'valueChange',
                callback: this._handleValueChange.bind(this)
            }]
        });
        this._fetchCourseList();
    }

    _fetchCourseList() {
        const coursesFetchUrl = EnvHelper.page.handle === 'feedback' ?
            `${ craft.env.apiSiteUrl }/feed/courses-feedback`
            : `${ craft.env.apiSiteUrl }/feed/coursesDropdown`;

        this.select.setButtonDisabled(true);
        return Api.get(coursesFetchUrl).then((data) => {
            this.select.importOptions(data);
            this.select.setButtonDisabled(false);

            if (EnvHelper.page.handle === 'courses-entry' && craft.page.courseDirectoryId) {
                this.select.selectOptionByValue(EnvHelper.page.courseDirectoryId);
            }

            this.finishLoading();
        });
    }

    _handleValueChange(value) {
        this.controller.setValue(value);
        this._setStatus(this.controller.valid ? 'valid' : 'neutral');

        const entryId = this._getEntryId();
        if (entryId) {
            this.controller.dispatch(this.GET_ENTRYID_ON_VALUE_CHANGE_EVENT, entryId);
        }
    }

    _getEntryId() {
        const $selectedOption = this.$root.querySelector('[aria-selected]');
        if ($selectedOption == null || !$selectedOption.dataset || !$selectedOption.dataset.entryId) {
            return false;
        }
        return $selectedOption.dataset.entryId;
    }

    _refresh() {
        this.select.setInitialState();
        this.controller.setValue(null);
    }
}